export default __webpack_public_path__ + "static/media/Foto galerija 3.c096d0ee.jpg";